import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        this.webappBg = document.querySelector('.webapp-background');
        this.additionalOptions = this.element.querySelector('.additional-options');
    }

    expandMenu(e) {
        e.preventDefault();
        if (this.additionalOptions !== null) {
            this.additionalOptions.classList.toggle('active');
            e.currentTarget.classList.toggle('active')
        }
    }

    expandLogin() {
        if (this.webappBg !== null) {
            this.webappBg.style.height = '100px';
        }
    }

    shrinkLogin() {
        if (this.webappBg !== null) {
            this.webappBg.style.height = null;
        }
    }
}
